// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3q7eD","footer":"ReportModalFilter_footer__2EmdC"};